import { TextField } from "@mui/material";
import { ChangeEvent, useEffect, useState } from "react";

export interface Props {
  minCharsForSearch: number;
  label: string;
  autoFocus?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export function SearchInput(props: Props) {
  const { label, autoFocus, onChange } = props;

  return <TextField data-testid="search-input" fullWidth variant="filled" autoFocus={autoFocus} label={label} value={props.value} onChange={onChange} />;
}
